<template lang="pug">
    a(
        class="_btn",
        :class="{ [tone]: tone, [appearance]: appearance, _busy: busy }",
        :href="_href",
        :id="id",
        :inert="inert",
        :tabindex="inert ? -1 : tabindex",
        v-on="__on",
        @dragstart.prevent="")
        slot
</template>

<script>
    import button from './ib-button.vue'

    /**
     * A button that is rendered using an `<a>` tag and acts as a link to a route or URL.
     * Rendering links using an `<a>` tag allows features like "Open in new window" to work
     * properly.
     *
     * `<a>` attributes such as `target` and `rel` will be handled as non-prop attributes
     * and passed directly.
     */
    export default {
        name: 'ib-button-link',
        mixins: [button],

        props: {
            /**
             * A hyperlink URL.
             */
            href: String,
            /**
             * A vue-router route; button will behave like `router-link`. This is an alternative
             * to `href`.
             */
            route: [String,Object]
        },

        computed: {
            _href() {
                if (this.href != null) {
                    return this.href;
                }
                if (this.route != null) {
                    return this.$router.resolve(this.route, this.$route).href;
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    a._btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        -webkit-user-drag: none;
        user-drag: none;
        color: @fg-button;
        background-color: @bg-button;
        text-decoration: none !important;
        will-change: unset !important;
        filter: none !important;
    }
</style>

<docs>
    ```jsx
        <div>
            <ib-button-link href="https://www.interactivebrokers.com">Go to IBKR Homepage</ib-button-link>
            <ib-button-link route="/">Go to Home Route</ib-button-link>
        </div>
    ```
</docs>
